export default "__VITE_ASSET__BeN9ngbG__"